import React from "react"
import { Link } from "react-router-dom"
import ContentCard from "../../ContentCard"
import HomePageProductCard from "../../HomePageProductCard"
import { etrColorInsights } from "../../../shared/images"

export const HomePageCard = (props) => {
  return (
    <Link
      to={props.data.link}
      className="home-page-card card-anim"
      onClick={() =>
        props.trackEvent("Clicked Card", {
          section: `AuthHomePage ${props.section.title} Section: ${props.section.innerTitle} Card`,
          link: props.data.link,
        })
      }
    >
      <div
        id="hp-card-image"
        style={{ backgroundImage: `url('${props.data.image}')` }}
      />
    </Link>
  )
}

export const EtrInsights = (props) => {
  let { upcoming } = props
  let { past } = props

  return (
    <ContentCard style={{ height: "100%" }}>
      <img
        src={etrColorInsights}
        style={{ marginBottom: ".8rem", maxWidth: 250 }}
      />
      {upcoming && upcoming.length > 0 ? (
        <div>
          <h3 className="home-page-list-title">Upcoming Events:</h3>
          <div className="two-x-two-list">
            {upcoming &&
              upcoming
                .slice(0, 4)
                .map((item) => <HomePageProductCard {...item} key={item.id} />)}
          </div>
        </div>
      ) : null}

      <div>
        <h3 className="home-page-list-title">Past Events:</h3>
        <div className="two-x-three-list">
          {past &&
            past
              .slice(0, 6)
              .map((item) => <HomePageProductCard {...item} key={item.id} />)}
        </div>
      </div>
    </ContentCard>
  )
}
